module.exports = __webpack_public_path__ + "static/painting-7d6dc637a536d8407c505edcd9420c5d.jpg";